import { ScrollBehavior } from 'data-types-config';
import type { AnchorPatternProps } from './AnchorPattern.types';

export const anchorPatternDefaults: Partial<AnchorPatternProps> = {
  scrollBehavior: ScrollBehavior.Auto,
  isDisabled: false,
  isVisible: true,
  text: '',
};
